import React from 'react';
import {Outlet} from "react-router-dom";
import {RequireOperator} from "context/OperatorContext";
import {AuthPageWrapper} from "../pages/Login/AuthPageWrapper";

function Unauthenticated() {

    return (
        <RequireOperator>
          <AuthPageWrapper>
            <Outlet/>
          </AuthPageWrapper>
        </RequireOperator>
    );
}

export default Unauthenticated;